<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/static-content">Static Content Management </a>
            </li>
            <li class="breadcrumb-item active">
                Terms & Conditions
            </li>
            <li class="breadcrumb-item active">Edit</li>
        </ol>
        <div class="order-view mt30 mrgn-0-auto p-5">
            <div class="form-group row p-3">
                <label class="col-md-2"> Title : </label>
                <div class="col-md-4">
                    <input type="text" value="" [(ngModel)]="title" class="form-control" placeholder="Title" id="">
                </div>
            </div>
            <ckeditor rows="10" ngSkipHydration [(ngModel)]="description" [editorUrl]="'//://cdn.ckeditor.com'">
            </ckeditor>
            <div class="my-4 text-center">
                <button class="btn btn-theme" [disabled]="title == '' || description == ''"
                    (click)="editStatic()">Save</button>
            </div>
        </div>
    </div>
</main>